import { Stack } from '@mui/material';
import RichText from '../index';
import Optional from '../../Optional';
import SliderImage from '../../gallery/SliderImage';
import DarkThemeProvider from '../../../providers/DarkThemeProvider';
import RichCtaButton from '../../elements/RichCtaButton';
import { MarkdownCtaPanel } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';
import linkMapper from '../../../utils/mappers/link';
import LightThemeProvider from '../../../providers/LightThemeProvider';
import imgMapper from '../../../utils/mappers/image';
import { useSectionContext } from '../../sections/utils/SectionContext';

const CtaPanel = ({
  cta: _cta,
  variant,
  direction,
  title,
  subtitle,
  image: _image,
  theme,
}: DeepNullToUndefined<MarkdownCtaPanel>) => {
  const { config } = useSectionContext();
  const blogHubSlug = config.other?.blogHubSlug ?? 'blog';
  const cta = linkMapper(_cta, true, { blogHubSlug });
  const image = imgMapper(_image);
  const isRight = direction === 'right';
  const isFull = variant === 'full';
  const isImage = !!image;
  const oppositeDirection = direction === 'right' ? 'left' : 'right';
  const Wrapper = theme === 'dark' ? DarkThemeProvider : LightThemeProvider;
  return (
    <Wrapper>
      <Stack
        className={'tb-cta-panel-container'}
        direction={{
          xs: 'column',
          md: isRight ? 'row-reverse' : 'row',
        }}
        sx={{
          width: {
            md: isFull ? '100%' : 'calc(50% - 16px)',
            xs: '100%',
          },
          my: 4,
          ml: {
            md: isRight && !isFull ? 2 : 0,
          },
          mr: {
            md: !isRight && !isFull ? 2 : 0,
          },
          p: { xs: 2, md: 4 },
          bgcolor: 'background.paper',
          borderRadius: { xs: 0.5, md: 1 },
          alignItems: 'stretch',
          float: {
            xs: 'none',
            md: !isFull ? direction : 'none',
          },
        }}
        spacing={2}
      >
        <SliderImage
          afterImage={image}
          sx={{ borderRadius: 0.5, height: { xs: 150, md: 200 } }}
        />
        <Stack
          spacing={1}
          sx={{
            width: '100%',
            color: 'text.primary',
            justifyContent: 'space-between',
          }}
        >
          <Stack spacing={1}>
            <Optional condition={!!title}>
              <RichText
                withTypography
                variant={'h3'}
                component={'p'}
                sx={{ textAlign: isImage ? oppositeDirection : direction }}
              >
                {title}
              </RichText>
            </Optional>
            <Optional condition={!!subtitle}>
              <RichText>{subtitle}</RichText>
            </Optional>
          </Stack>
          <Optional condition={!!cta}>
            <RichCtaButton
              cta={cta}
              track={{
                position: 'markdown_ctaPanel',
              }}
              sx={{
                alignSelf: isRight ? 'start' : 'end',
                justifySelf: 'end',
              }}
            />
          </Optional>
        </Stack>
      </Stack>
    </Wrapper>
  );
};
export default CtaPanel;
